import React from 'react';
import PropTypes from 'prop-types';
// import classnames from 'classnames';

import { withUAPLThemedStyles } from '../with-themed-styles';
import { getPromotionExtensionStyles } from '../styles';
import star from './media/star.svg';

const PromotionExtension = ({
  classes,
  extensionData,
}) => (
  extensionData.map(({
    Occasion, PromotionType, PromotionItem, PromotionDetail, DateRange, hasOccasion, hasPromotionDetail, hasDateRange,
  }) => (
    <div className={classes.promotionExtensionContainer}>
      <div className="promotion-info">
        {hasOccasion && <span>{`${Occasion}: `}</span>}
        <span className="discount">{PromotionType}</span>
        <span>{` · ${PromotionItem}`}</span>
        {hasPromotionDetail && <span>{` · ${PromotionDetail}`}</span>}
        {hasDateRange && <span>{` · ${DateRange}`}</span>}
      </div>
      <div className="promotion-rate">
        <span>5/5</span>
        <div className="rating-icons">
          {[...Array(5)].map(() => (
            <img src={star} alt="star" />
          ))}
        </div>
        <span className="reviews">(1,000 reviews)</span>
      </div>
    </div>
  ))
);

PromotionExtension.propTypes = {
  classes: PropTypes.shape({
    promotionExtensionContainer: PropTypes.string,
  }),
  extensionData: PropTypes.arrayOf(PropTypes.shape({
    Occasion: PropTypes.string,
    PromotionType: PropTypes.string,
    PromotionItem: PropTypes.string,
    PromotionDetail: PropTypes.string,
    DateRange: PropTypes.string,
    hasOccasion: PropTypes.bool,
    hasPromotionDetail: PropTypes.bool,
    hasDateRange: PropTypes.bool,
  })),
};

PromotionExtension.defaultProps = {
  classes: {},
  extensionData: [],
};

export const AdPreviewPromotionExtension = withUAPLThemedStyles(
  PromotionExtension,
  getPromotionExtensionStyles, { componentName: 'AdPreviewPromotionExtension' }
);
